<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="40vw" top="1vh" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <!-- 编码 -->
      <el-form-item label="品牌名" prop="brand_name">
        <el-input v-model.trim="form.brand_name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="海关备案码" prop="code">
        <el-input v-model.trim="form.code" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="商品税号" prop="tax_id">
        <el-input v-model.trim="form.tax_id" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="商品条码" prop="barcode">
        <el-input v-model.trim="form.barcode" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="中文品名" prop="goods_name">
        <el-input v-model.trim="form.goods_name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="英文品名" prop="en_goods_name">
        <el-input v-model.trim="form.en_goods_name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="规格型号" prop="sku">
        <el-input v-model.trim="form.sku" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="原产国" prop="origin">
        <el-input v-model.trim="form.origin" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="计量单位" prop="unit">
        <el-input v-model.trim="form.unit" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="商品净重/Kg" prop="net_weight">
        <el-input v-model.trim="form.net_weight" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="商品毛重/Kg" prop="gross_weight">
        <el-input v-model.trim="form.gross_weight" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="申报单价" prop="declared_unit_price">
        <el-input v-model.trim="form.declared_unit_price" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="税率" prop="tax_rate">
        <el-input v-model.trim="form.tax_rate" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="税金" prop="tax">
        <el-input v-model.trim="form.tax" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>
       <el-form-item label="是否监管" prop="supervision">
        <el-tooltip>
  <el-switch
    v-model="form.supervision"
    active-color="#13ce66"
    inactive-color="#ccc"
    active-value="1"
    inactive-value="0">
  </el-switch>
</el-tooltip>
      </el-form-item>



    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    valid
  } from 'mockjs'
  import {
    BrandFilingDetail,
    brandUpdate,
    BrandFilingUpdate,
    Index_country_list
  } from '@/api/xgcApi'

  export default {
    name: 'ManageStore',
    data() {
      return {
        form: {
          kor_type:null,
          name:null,
          sort:null,




"brand_name": "", //品牌名
"code": "", //海关备案码
"tax_id": "", //商品税号
"barcode": "", //商品条码
"goods_name": "", //中文品名
"en_goods_name": "", //英文品名
"sku": "", //规格型号
"origin": "", //原产国
"unit": "", //计量单位
"net_weight": "", //商品净重/Kg
"gross_weight": "", //商品毛重/Kg
"declared_unit_price": "", //申报单价
"tax_rate": "", //税率
"tax": "", //税金
"supervision": "" //是否监管 0否 1是

        },
        rules: {
          brand_name: [{
            required: true,
            trigger: 'blur',
            message: '请输入名称'
          }],
        },
        options:[],
        title: '',
        dialogFormVisible: false,
        isShow: true,
      }
    },
    created() {},
    methods: {
      getBrand(){
        var data = {}
        Index_country_list(data).then(res=>{
          this.options = res.data
        })
      },
      handleInput() {
        // Remove non-numeric characters and leading zeros
        this.form.sort = this.form.sort.replace(/\D/g, '').replace(/^0+/, '')
      },
      showEdit(row) {
        var data = {}
        Index_country_list(data).then(res=>{
          this.options = res.data
          if (!row) {
            this.title = '添加'
            this.isShow = false
          } else {

console.log(row,'99999')

            this.isShow = true
            this.title = '编辑'
            // const {
            //   data
            // } = await BrandFilingDetail(row.id)
            // this.form = data
            // this.form = Object.assign({}, row)
            BrandFilingDetail({id:row.id}).then(req=>{
                this.form = req.data
                // this.form = Object.assign({}, row)
            })
          }
          this.dialogFormVisible = true
        })

      },
      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
        this.$emit('fetch-data')
      },
      save() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            if (this.isShow == false) {
              const {
                msg
              } = await BrandFilingUpdate(this.form)
              this.$baseMessage(msg, 'success')
              this.$refs['form'].resetFields()
              this.dialogFormVisible = false
              this.$emit('fetch-data')
              this.form = this.$options.data().form
            } else {
              const {
                msg
              } = await BrandFilingUpdate(this.form)
              this.$baseMessage(msg, 'success')
              this.$refs['form'].resetFields()
              this.dialogFormVisible = false
              this.$emit('fetch-data')
              // this.form = this.$options.data().form
            }
          } else {
            return false
          }
        })
      },
    },
  }
</script>
